import React from 'react';
import useModalFocus from '@/hooks/useModalFocus';

/** Shared keyboard handling for the app's custom drawers and dialogs. */
export default function ModalSurface({ onDismiss, children, label = 'Record details', ...props }) {
  const panel = useModalFocus(true, onDismiss);
  // Escape, Tab and focus restoration are handled by useModalFocus; only background clicks dismiss.
  // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
  return <div {...props} ref={panel} role="dialog" aria-modal="true" aria-label={label} tabIndex={-1}
    onClick={event => { if (event.target === event.currentTarget) onDismiss?.(); }}>
    {children}
  </div>;
}
